//footer principal
"use client";

import React from 'react';


const Footer = () => {
  return ( 
    <footer className="bg-transparent shadow">
      <div className="w-full mx-auto p-4 md:py-8">
        <div className="sm:flex sm:items-center sm:justify-between">
          <a className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
            <img src="https://storage.googleapis.com/drago-imagenes-bucket/favicon.ico" className="h-8" alt="dravvt logo" />
            <span className="self-center text-2xl font-semibold whitespace-nowrap text-neutral-950 dark:text-blue-100">Dravvt</span>
          </a>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-neutral-700 dark:text-blue-100 sm:mb-0">
            <li>
              <a href="/aboutme" className="hover:underline me-4 md:me-6"> About </a>
            </li>
            <p className= "text-neutral-950 dark:text-blue-100"> - </p>
            <li>
              <a href="/privacyPolicy" className="hover:underline me-4 md:me-6"> Privacy Policy </a>
            </li>
         </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto lg:my-8" />
        <span className="block text-sm dark:text-blue-100 text-neutral-700 sm:text-center">
          © 2025{' '}
          <a href="/" className="hover:underline">Dravvt™</a>
          . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;


